/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CandidateMessage } from './CandidateMessage';
import {
    CandidateMessageFromJSON,
    CandidateMessageFromJSONTyped,
    CandidateMessageToJSON,
} from './CandidateMessage';
import type { HelpLink } from './HelpLink';
import {
    HelpLinkFromJSON,
    HelpLinkFromJSONTyped,
    HelpLinkToJSON,
} from './HelpLink';
import type { Parent } from './Parent';
import {
    ParentFromJSON,
    ParentFromJSONTyped,
    ParentToJSON,
} from './Parent';
import type { TimeZoneInfo } from './TimeZoneInfo';
import {
    TimeZoneInfoFromJSON,
    TimeZoneInfoFromJSONTyped,
    TimeZoneInfoToJSON,
} from './TimeZoneInfo';

/**
 * 
 * @export
 * @interface CalendarEvent
 */
export interface CalendarEvent {
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    type?: string;
    /**
     * 
     * @type {Parent}
     * @memberof CalendarEvent
     */
    parent?: Parent;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    urlName?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly updateDate?: string;
    /**
     * 
     * @type {Date}
     * @memberof CalendarEvent
     */
    publishedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    helpText?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    helpVideo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    showHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    showExtendedHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    pushContent?: boolean;
    /**
     * 
     * @type {Array<HelpLink>}
     * @memberof CalendarEvent
     */
    helpLinks?: Array<HelpLink>;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    eventType?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly endTime?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    leadIn?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    thumbnail?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    practicalInformation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    isAppointment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    videoMeeting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    onlineLink?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    organiser?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    organiserEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    organiserDisplayEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    organiserPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    organiserId?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    city?: string;
    /**
     * 
     * @type {number}
     * @memberof CalendarEvent
     */
    numberOfSeats?: number;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    livestreamLink?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    eventTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    programmeActivityFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    teamsMeetingJoinUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    directions?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    directionsEnglish?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof CalendarEvent
     */
    appliesToCandidateProgramStates?: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly eventDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly month?: string;
    /**
     * 
     * @type {Date}
     * @memberof CalendarEvent
     */
    eventEndDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CalendarEvent
     */
    eventStartDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    hasMemberSigned?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CalendarEvent
     */
    numberOfSignups?: number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEvent
     */
    cancellationDeadlineHours?: number;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    cancellationInfoBeforeDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    cancellationInfoAfterDeadline?: string;
    /**
     * 
     * @type {TimeZoneInfo}
     * @memberof CalendarEvent
     */
    timeZone?: TimeZoneInfo;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    readonly timeZoneAbbreviation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    readonly isEventExpired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    readonly isEventTomorrowOrLater?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEvent
     */
    readonly isEventToday?: boolean;
    /**
     * 
     * @type {Array<CandidateMessage>}
     * @memberof CalendarEvent
     */
    candidateMessages?: Array<CandidateMessage>;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    participantStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEvent
     */
    modernUrl?: string;
}

/**
 * Check if a given object implements the CalendarEvent interface.
 */
export function instanceOfCalendarEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CalendarEventFromJSON(json: any): CalendarEvent {
    return CalendarEventFromJSONTyped(json, false);
}

export function CalendarEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'url': !exists(json, 'Url') ? undefined : json['Url'],
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'parent': !exists(json, 'Parent') ? undefined : ParentFromJSON(json['Parent']),
        'urlName': !exists(json, 'UrlName') ? undefined : json['UrlName'],
        'updateDate': !exists(json, 'UpdateDate') ? undefined : json['UpdateDate'],
        'publishedDate': !exists(json, 'PublishedDate') ? undefined : (new Date(json['PublishedDate'])),
        'helpText': !exists(json, 'HelpText') ? undefined : json['HelpText'],
        'helpVideo': !exists(json, 'HelpVideo') ? undefined : json['HelpVideo'],
        'showHelp': !exists(json, 'ShowHelp') ? undefined : json['ShowHelp'],
        'showExtendedHelp': !exists(json, 'ShowExtendedHelp') ? undefined : json['ShowExtendedHelp'],
        'pushContent': !exists(json, 'PushContent') ? undefined : json['PushContent'],
        'helpLinks': !exists(json, 'HelpLinks') ? undefined : ((json['HelpLinks'] as Array<any>).map(HelpLinkFromJSON)),
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'category': !exists(json, 'Category') ? undefined : json['Category'],
        'eventType': !exists(json, 'EventType') ? undefined : json['EventType'],
        'startDate': !exists(json, 'StartDate') ? undefined : json['StartDate'],
        'endDate': !exists(json, 'EndDate') ? undefined : json['EndDate'],
        'startTime': !exists(json, 'StartTime') ? undefined : json['StartTime'],
        'endTime': !exists(json, 'EndTime') ? undefined : json['EndTime'],
        'leadIn': !exists(json, 'LeadIn') ? undefined : json['LeadIn'],
        'image': !exists(json, 'Image') ? undefined : json['Image'],
        'thumbnail': !exists(json, 'Thumbnail') ? undefined : json['Thumbnail'],
        'content': !exists(json, 'Content') ? undefined : json['Content'],
        'practicalInformation': !exists(json, 'PracticalInformation') ? undefined : json['PracticalInformation'],
        'isAppointment': !exists(json, 'IsAppointment') ? undefined : json['IsAppointment'],
        'videoMeeting': !exists(json, 'VideoMeeting') ? undefined : json['VideoMeeting'],
        'onlineLink': !exists(json, 'OnlineLink') ? undefined : json['OnlineLink'],
        'organiser': !exists(json, 'Organiser') ? undefined : json['Organiser'],
        'organiserEmail': !exists(json, 'OrganiserEmail') ? undefined : json['OrganiserEmail'],
        'organiserDisplayEmail': !exists(json, 'OrganiserDisplayEmail') ? undefined : json['OrganiserDisplayEmail'],
        'organiserPhone': !exists(json, 'OrganiserPhone') ? undefined : json['OrganiserPhone'],
        'organiserId': !exists(json, 'OrganiserId') ? undefined : json['OrganiserId'],
        'location': !exists(json, 'Location') ? undefined : json['Location'],
        'address': !exists(json, 'Address') ? undefined : json['Address'],
        'zipCode': !exists(json, 'ZipCode') ? undefined : json['ZipCode'],
        'city': !exists(json, 'City') ? undefined : json['City'],
        'numberOfSeats': !exists(json, 'NumberOfSeats') ? undefined : json['NumberOfSeats'],
        'livestreamLink': !exists(json, 'LivestreamLink') ? undefined : json['LivestreamLink'],
        'subject': !exists(json, 'Subject') ? undefined : json['Subject'],
        'eventTemplateId': !exists(json, 'EventTemplateId') ? undefined : json['EventTemplateId'],
        'programmeActivityFormat': !exists(json, 'ProgrammeActivityFormat') ? undefined : json['ProgrammeActivityFormat'],
        'teamsMeetingJoinUrl': !exists(json, 'TeamsMeetingJoinUrl') ? undefined : json['TeamsMeetingJoinUrl'],
        'directions': !exists(json, 'Directions') ? undefined : json['Directions'],
        'directionsEnglish': !exists(json, 'DirectionsEnglish') ? undefined : json['DirectionsEnglish'],
        'appliesToCandidateProgramStates': !exists(json, 'AppliesToCandidateProgramStates') ? undefined : json['AppliesToCandidateProgramStates'],
        'eventDate': !exists(json, 'EventDate') ? undefined : json['EventDate'],
        'month': !exists(json, 'Month') ? undefined : json['Month'],
        'eventEndDate': !exists(json, 'EventEndDate') ? undefined : (new Date(json['EventEndDate'])),
        'eventStartDate': !exists(json, 'EventStartDate') ? undefined : (new Date(json['EventStartDate'])),
        'hasMemberSigned': !exists(json, 'HasMemberSigned') ? undefined : json['HasMemberSigned'],
        'numberOfSignups': !exists(json, 'NumberOfSignups') ? undefined : json['NumberOfSignups'],
        'cancellationDeadlineHours': !exists(json, 'CancellationDeadlineHours') ? undefined : json['CancellationDeadlineHours'],
        'cancellationInfoBeforeDeadline': !exists(json, 'CancellationInfoBeforeDeadline') ? undefined : json['CancellationInfoBeforeDeadline'],
        'cancellationInfoAfterDeadline': !exists(json, 'CancellationInfoAfterDeadline') ? undefined : json['CancellationInfoAfterDeadline'],
        'timeZone': !exists(json, 'TimeZone') ? undefined : TimeZoneInfoFromJSON(json['TimeZone']),
        'timeZoneAbbreviation': !exists(json, 'TimeZoneAbbreviation') ? undefined : json['TimeZoneAbbreviation'],
        'isEventExpired': !exists(json, 'IsEventExpired') ? undefined : json['IsEventExpired'],
        'isEventTomorrowOrLater': !exists(json, 'IsEventTomorrowOrLater') ? undefined : json['IsEventTomorrowOrLater'],
        'isEventToday': !exists(json, 'IsEventToday') ? undefined : json['IsEventToday'],
        'candidateMessages': !exists(json, 'CandidateMessages') ? undefined : ((json['CandidateMessages'] as Array<any>).map(CandidateMessageFromJSON)),
        'participantStatus': !exists(json, 'ParticipantStatus') ? undefined : json['ParticipantStatus'],
        'modernUrl': !exists(json, 'ModernUrl') ? undefined : json['ModernUrl'],
    };
}

export function CalendarEventToJSON(value?: CalendarEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Title': value.title,
        'Url': value.url,
        'Type': value.type,
        'Parent': ParentToJSON(value.parent),
        'UrlName': value.urlName,
        'PublishedDate': value.publishedDate === undefined ? undefined : (value.publishedDate.toISOString()),
        'HelpText': value.helpText,
        'HelpVideo': value.helpVideo,
        'ShowHelp': value.showHelp,
        'ShowExtendedHelp': value.showExtendedHelp,
        'PushContent': value.pushContent,
        'HelpLinks': value.helpLinks === undefined ? undefined : ((value.helpLinks as Array<any>).map(HelpLinkToJSON)),
        'Status': value.status,
        'Category': value.category,
        'EventType': value.eventType,
        'LeadIn': value.leadIn,
        'Image': value.image,
        'Thumbnail': value.thumbnail,
        'Content': value.content,
        'PracticalInformation': value.practicalInformation,
        'IsAppointment': value.isAppointment,
        'VideoMeeting': value.videoMeeting,
        'OnlineLink': value.onlineLink,
        'Organiser': value.organiser,
        'OrganiserEmail': value.organiserEmail,
        'OrganiserDisplayEmail': value.organiserDisplayEmail,
        'OrganiserPhone': value.organiserPhone,
        'OrganiserId': value.organiserId,
        'Location': value.location,
        'Address': value.address,
        'ZipCode': value.zipCode,
        'City': value.city,
        'NumberOfSeats': value.numberOfSeats,
        'LivestreamLink': value.livestreamLink,
        'Subject': value.subject,
        'EventTemplateId': value.eventTemplateId,
        'ProgrammeActivityFormat': value.programmeActivityFormat,
        'TeamsMeetingJoinUrl': value.teamsMeetingJoinUrl,
        'Directions': value.directions,
        'DirectionsEnglish': value.directionsEnglish,
        'AppliesToCandidateProgramStates': value.appliesToCandidateProgramStates,
        'EventEndDate': value.eventEndDate === undefined ? undefined : (value.eventEndDate.toISOString()),
        'EventStartDate': value.eventStartDate === undefined ? undefined : (value.eventStartDate.toISOString()),
        'HasMemberSigned': value.hasMemberSigned,
        'NumberOfSignups': value.numberOfSignups,
        'CancellationDeadlineHours': value.cancellationDeadlineHours,
        'CancellationInfoBeforeDeadline': value.cancellationInfoBeforeDeadline,
        'CancellationInfoAfterDeadline': value.cancellationInfoAfterDeadline,
        'TimeZone': TimeZoneInfoToJSON(value.timeZone),
        'CandidateMessages': value.candidateMessages === undefined ? undefined : ((value.candidateMessages as Array<any>).map(CandidateMessageToJSON)),
        'ParticipantStatus': value.participantStatus,
        'ModernUrl': value.modernUrl,
    };
}

